import { MessageCircle } from "lucide-react";
import { LINKS } from "@/data/content";

export default function WhatsAppFloat() {
  return (
    <a
      href={LINKS.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrivimi su WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.35)] hover:scale-110 transition-transform duration-300"
    >
      <MessageCircle size={26} />
    </a>
  );
}
